import React from 'react'
import Icon from './Icon'

export default props => (
  <a href={props.href} target="_blank" rel="noopener noreferrer">
    <Icon {...props} cursorType="pointer" />
  </a>
)



// WEBPACK FOOTER //
// ../components/IconLink.js